import React from 'react';

const LogoutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7265_478)">
      <path
        d="M15.0013 18.3332H5.83464C4.91547 18.3332 4.16797 17.5857 4.16797 16.6665V14.1665H5.83464V16.6665H15.0013V3.33317H5.83464V5.83317H4.16797V3.33317C4.16797 2.41484 4.91547 1.6665 5.83464 1.6665H15.0013C15.9205 1.6665 16.668 2.41484 16.668 3.33317V16.6665C16.668 17.5857 15.9205 18.3332 15.0013 18.3332Z"
        fill="#B9BDC4"
      />
      <path
        d="M9.75648 6.07666L8.57815 7.25666L10.4923 9.16666H3.33398V10.8333H10.4857L8.57732 12.745L9.75732 13.9217L13.679 9.99249L9.75648 6.07666Z"
        fill="#B9BDC4"
      />
    </g>
    <defs>
      <clipPath id="clip0_7265_478">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LogoutIcon;
